<!-- 此页面有三种用途
1. 管理员、业务员编辑用户
2. 管理员创建后管用户
3. 业务员创建用户 -->
<template>
  <el-dialog v-if="DialogVisible" :visible.sync="DialogVisible" width="850px" class="large-padding-dialog"
    :close-on-click-modal="false" :before-close="Hide">
    <span slot="title" class="el-dialog__title">
      <template v-if="Type == 'Create'">
        新增{{ DialogFormData.is_backend ? "后管" : "" }}用户
      </template>
      <template v-else>管理{{ DialogFormData.is_backend ? "后管" : "" }}用户：{{ DialogFormData.id }}</template>
    </span>
    <!--当用户通过点击关闭图标或遮罩关闭 Dialog 时触发 before-close 对应方法-->
    <el-form :model="DialogFormData" ref="DialogFormData" :rules="dialogRules">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-row>
            <el-form-item label="账号 (手机号)" prop="mobile">
              <el-input v-model="DialogFormData.mobile" placeholder="请输入账号"
                :disabled="Type == 'View' || Type == 'Edit'"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="用户昵称" prop="display_name">
              <el-input v-model="DialogFormData.display_name" placeholder="请输入用户昵称"
                :disabled="Type == 'View'"></el-input>
            </el-form-item>
          </el-row>

          <el-row v-if="Type == 'Create'">
            <el-form-item label="密码" prop="password">
              <el-input v-model="DialogFormData.password" placeholder="请输入密码" :disabled="Type == 'View'"></el-input>
            </el-form-item>
          </el-row>

          <el-row v-if="DialogFormData.is_backend">
            <el-form-item label="后管角色" prop="role_id">
              <el-select v-model="DialogFormData.role_id" :disabled="Type == 'View'">
                <el-option v-for="item in roleList.filter((item) => item.type == 3)" :key="item.id"
                  :label="item.display_name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-row>

          <el-row v-if="!DialogFormData.is_backend">
            <el-form-item :label="l('预填企业名称')" prop="pre_company_name">
              <el-input v-model="DialogFormData.pre_company_name" :placeholder="l('请输入') + l('企业名称')" :disabled="Type == 'View'"></el-input>
            </el-form-item>
          </el-row>

          <el-row v-if="!DialogFormData.is_backend&&Type=='Create'">
            <el-form-item :label="l('主营业务')" prop="pre_business_tag_id">
              <el-select v-model="DialogFormData.pre_business_tag_id" :placeholder="l('请选择') + l('主营业务')" :disabled="Type == 'View'">
                <el-option
                  v-for="item of $store.state.basicInfo.tagList.pre_business"
                  :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
              <!-- .filter(item => $store.getters.checkRole(item.extra_params.manager_role_id)) -->
            </el-form-item>
          </el-row>
        </el-col>
        <el-col :span="12">
          <el-row>
            <ResourceUpLoad label="头像" usage="avatar" :initResourceUrl.sync="DialogFormData.avatar"
              :disabled="Type == 'View'" />
          </el-row>
        </el-col>
      </el-row>

      <el-row>
        <el-form-item label="个人简介" prop="description">
          <el-input type="textarea" v-model="DialogFormData.description" placeholder="将在论坛个人首页展示" :rows="3"
            :disabled="Type == 'View'" :maxlength="50" :show-word-limit="true" :clearable="true"
            resize="none"></el-input>
        </el-form-item>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="Hide">{{ l("取 消") }}</el-button>
      <el-button v-if="
        Type == 'View' && $store.getters.checkPermission('admin_user.edit')
      " type="warning" @click="Type = 'Edit'">{{ l("修 改") }}</el-button>
      <el-button v-if="Type == 'Create' || Type == 'Edit'" type="primary" @click="submitForm">{{ l("保 存") }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import dialogMixin from "@/assets/js/dialogMixin";

export default {
  name: "CreateOrEditUser",
  mixins: [dialogMixin],
  props: ["roleList"],
  data() {
    var validateNewPassword = (rule, value, callback) => {
      // if (!/^[a-zA-Z](\w){5,19}$/.test(value)) {
      if (!/^(\w){6,20}$/.test(value)) {
        callback(new Error("请输入6-20位的英文/数字密码"));
      } else {
        callback();
      }
    };
    var validateMobile = (rule, value, callback) => {
      if (!/^[0-9]+$/.test(value)) {
        callback(new Error("账号必须为数字"));
      } else {
        callback();
      }
    };
    return {
      DialogFormData: {
        id: null,
        avatar: null,
        mobile: "",
        password: "",
        display_name: "",
        role_id: null,
        description: "",

        role_list: [],

        is_backend: 0,

        pre_company_name: "",
        pre_business_tag_id: null
      },
      dialogRules: {
        mobile: [
          {
            required: true,
            message: this.l("请输入") + this.l("手机号"),
            trigger: "blur",
          },
          { validator: validateMobile, trigger: "change" },
        ],
        display_name: [
          { required: true, message: "请输入用户昵称", trigger: "blur" },
          {
            min: 2,
            max: 16,
            message: "长度在 2 到 16 个字符",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "change" },
          { validator: validateNewPassword, trigger: "change" },
        ],
        role_id: [{ required: true, message: "请选择角色", trigger: "blur" }],

        pre_company_name: [{ required: true, message: "请输入企业名称", trigger: "blur" }],
        pre_business_tag_id: [{ required: true, message: "请选择主营业务类型", trigger: "blur" }],
      },
    };
  },
  methods: {
    AfterShow() {
      this.DialogFormData.role_id = this.DialogFormData.role_list.find(
        (role_id) =>
          this.roleList
            .filter((item) => item.type == 3)
            .some((role) => role.id == role_id)
      );
      console.log("DialogFormData", this.DialogFormData);
    },
    submitForm() {
      this.$refs["DialogFormData"].validate((valid, obj) => {
        if (!valid) {
          return this.$message.error(obj[Object.keys(obj)[0]][0].message);
        }

        if (this.Type == "Create") {
          if (this.DialogFormData.is_backend) {
            this.axios
              .post(`/api/admin_user/`, this.DialogFormData)
              .then((data) => {
                this.$emit("submitDialog");
                this.Hide();
              });
          } else {
            this.axios
              .post(`/api/admin_user/create_normal_user/`, this.DialogFormData)
              .then((data) => {
                this.$emit("submitDialog");
                this.Hide();
              });
          }

        } else {
          this.axios
            .put(
              `/api/admin_user/${this.DialogFormData.id}/`,
              this.DialogFormData
            )
            .then((data) => {
              this.$emit("submitDialog");
              //如果是改自己则还要更新自己信息
              if (this.DialogFormData.id == this.$store.state.session.user.id) {
                this.$store.dispatch("updateSession");
              }
              this.Hide();
            });
        }
      });
    },
  },
};
</script>


<style scoped lang="scss"></style>
